import { createFileRoute } from "@tanstack/react-router";
import { AttachmentsPage } from "@/features/attachments/AttachmentsPage";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/attachments")({
  beforeLoad: requireAuth,
  component: AttachmentsPage,
});
